import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { editMaisEguById } from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getFirstFormError, getResponseError, setFormError } from '../../../utils/utils';
import MaisEguDTO from '../../../dto/MaisEguDTO';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { MAIS_EGU_TYPE_STATUS_LIST } from '../../../configs';
import WysiwygInput from '../../../components/fields/TextInput/WysiwygInput';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';

export default function MaisEguForm(props) {
  const {
    close = () => {},
    loadData = () => {},
    current = {},
  } = props;
  const dispatch = useDispatch();
  const {
    control,
    getValues,
    formState: { errors },
    setError,
    setFocus,
  } = useForm({
    mode: 'onChange',
    defaultValues: current,
  });
  const cronSetting = `${process.env.PUBLIC_URL}/img/cron.png`;

  const handleSave = () => {
    const error = getFirstFormError(errors);
    if (error) {
      errorNotification('Сохранение формы МАИС ЭГУ', 'Ошибка заполнения формы');
      const { ref } = error;
      if (ref && ref.name) {
        setFocus(ref.name);
      }
      return null;
    }
    const values = getValues();
    dispatch(editMaisEguById({ ...values, id: current.id }))
      .then(() => {
        loadData();
        close();
        successNotification('Сохранение формы МАИС ЭГУ', 'Форма сохранена');
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение формы МАИС ЭГУ', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const DTO = new MaisEguDTO();
  const attributes = DTO.getAttributesByName();

  return (
    <Dialog
      className="application-denied-dialog"
      onClose={close}
      open
    >
      <DialogTitle header="Изменение настройки МАИС ЭГУ" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.procedure}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.name}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={WysiwygInput}
            dtoObject={attributes.description}
            placeholder=""
            withLabel
            textarea
            variant="material"
            // handleShowHelper={handleShowHelper}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.cron}
            variant="material"
            inputAfter={(
              <TooltipWithPortal
                content={<Icons customIcon сlassName="help-icon" icon="help" />}
                classNamePortal="more-actions"
                tooltipContent={(
                  <img
                    className="mini-cron-setting"
                    src={cronSetting}
                    alt="A"
                    onError={e => {
                      e.target.src = cronSetting;
                    }}
                  />
                  )}
                classNameWrapper="more-tooltip-wrapper"
                className="more-tooltip"
              />
            )}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            options={MAIS_EGU_TYPE_STATUS_LIST}
            withLabel
            variant="material"
          />
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={close}>Отменить</Button>
          <Button className="hff-clear-show" type="submit" onClick={handleSave}>Сохранить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
